import Vue from "vue";
import transformer from "@/transformers/invoiceReceipt";
import moment from "moment";

function paramsTransformer({
  page,
  size,
  from,
  to,
  searchQuery,
  customer,
  pageSize,
  stamped,
  validated,
}) {
  return {
    page: page - 1,
    from: from ? moment(from).format("YYYY/MM/DD") : null,
    to: to ? moment(to).format("YYYY/MM/DD") : null,
    text: searchQuery,
    customer,
    size: pageSize || size,
    stamped: stamped,
    validated: validated,
  };
}

function paginationTransformer({ totalItems, page, size }) {
  const next = (page + 1) * size < totalItems ? page + 2 : null;
  const previous = page + 1 > 1 ? page : null;
  const paginationInfo = {
    count: totalItems,
    next,
    previous,
  };
  return paginationInfo;
}

export default (fetchParams) => {
  let url = `taxreceipt/invoicereceipt/`;

  const config = { params: paramsTransformer(fetchParams) };

  return Vue.$http.get(url, config).then((response) => {
    const { result, ...paginationData } = response.data[0];
    const invoiceReceipts = transformer.fetchCollection(result);
    const paginationInfo = paginationTransformer(paginationData);

    return {
      invoiceReceipts,
      paginationInfo,
    };
  });
};



// WEBPACK FOOTER //
// ./src/services/taxReceipt/getInvoiceReceipt.js